import { getGrowlId, useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Modal } from "PFComponents/modal";
import { getProfileName } from "PFCore/helpers/profile";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { fillAndBookShortlist } from "PFCore/services/shortlist";
import { useTranslation } from "react-i18next";

import css from "./modals.module.scss";
import { FillRoleContent } from "./parts/fill_role_content";
import { useIsPotentiallyOverbooked } from "./parts/use_is_potentially_overbooked";
import { AuditPlannerModalProps } from "./types";

export const FillRoleModal = ({
  onClose,
  engagement,
  role,
  shortlistItem,
  onSuccess
}: AuditPlannerModalProps) => {
  const { showGrowl } = useGrowlStoreActions();
  const growlErrors = useErrorsGrowl();
  const { t } = useTranslation("auditPlanner");
  const { isErrorUnauthorized } = useResponseErrors();

  const { profile } = shortlistItem;

  const { isOverbooked, isFetching } = useIsPotentiallyOverbooked({
    profileId: profile.id,
    activityId: role.id
  });

  const handleSubmit = () =>
    fillAndBookShortlist(shortlistItem.id)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        showGrowl({
          id: getGrowlId("create-temporary-booking"),
          message: t("modals.temporaryBookingCreated", {
            name: getProfileName(profile)
          }),
          kind: "success",
          hidePreviousByTypeAndId: true,
          ttl: 5000
        });
      })
      .catch(({ response }) => {
        if (isErrorUnauthorized(response)) {
          showGrowl({
            kind: "error",
            message: t("modals.cannotFillRole")
          });
        } else {
          growlErrors(response);
        }
      });
  return (
    <Modal
      title={t("modals.fillRole")}
      subtitle={role.name}
      labelOK={t("modals.fillRole")}
      onOK={handleSubmit}
      disableOKButton={isFetching}
      onClose={onClose}
      classes={{ modal: css.modal, body: css.modalBody }}
    >
      <FillRoleContent
        engagement={engagement}
        profile={profile}
        shouldShowSoftOverbooking={isOverbooked}
        isFetching={isFetching}
      />
    </Modal>
  );
};
